import { Attr, BelongsTo, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';

@Model()
export default class WebauthnChallenge extends ApplicationRecord {
  static jsonapiType = 'webauthn_challenges';
  @Attr() data: string;
}
